






import { defineComponent } from '@vue/composition-api';

import AreaCodeEditor from '@/components/Setting/AreaCode/Editor.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

const Edit = defineComponent({
  components: {
    Breadcrumbs,
    AreaCodeEditor,
  },
  // setup() {},
});

export default Edit;
